import * as z from "zod/v4";

export const getMetaLeadAdsWebhookStatus = {
  name: "getMetaLeadAdsWebhookStatus" as const,
  input: z.object({ pageId: z.string() }),
  output: z.object({ isSubscribed: z.boolean() }),
};
